<div class="container fxflex fxcentercenter fxcolumn">
  <div id="tutorial-thread-selector" data-cy="thread-menu" class="fxcolumn fxstartcenter">
    <rtr-icon-button dataCy="thread-up" icon="up-sm" type="plain" [disabled]="upDisabled()" (click)="navigateUp()" />
    @for (thread of threads(); track thread.id; let index = $index) {
      <div
        class="dot-wrapper"
        [attr.data-cy]="'thread-' + index"
        (click)="onDotUsed(index)"
        [class.active]="thread.active"
      >
        <div data-cy="thread-dot" class="dot"></div>
      </div>
    }
    <rtr-icon-button
      dataCy="thread-down"
      icon="down-sm"
      type="plain"
      [disabled]="downDisabled()"
      (click)="navigateDown()"
    />
  </div>
</div>
